import React, { useEffect } from "react";
import {
  useLazyQuery,
  useMutation,
  useQuery as apolloQuery
} from "@apollo/react-hooks";
import { useHistory } from "react-router-dom";
import track from "react-tracking";
import routesConfig from "utils/routesConfig";
import { gql } from "apollo-boost";

export const SaveOuraTokens = gql`
  mutation saveOuraToken($input: SaveOuraTokensRequest!) {
    saveOuraTokens(input: $input) {
      success
    }
  }
`;

export const UpdateNotificationPreferencesMutation = gql`
  mutation UpdateNotificationPreferences(
    $input: UserNotificationPreferencesInput!
  ) {
    updateUserNotificationPreferences(input: $input) {
      success
    }
  }
`;

const Oura: React.FC = () => {
  const history = useHistory();
  const queryParameters = new URLSearchParams(window.location.search);
  const code = queryParameters.get("code");
  const scope = queryParameters.get("scope");
  const state = queryParameters.get("state");

  const [saveOuraTokensMutation] = useMutation(SaveOuraTokens);

  const [updateNotificationPreferencesMutation] = useMutation(
    UpdateNotificationPreferencesMutation
  );

  useEffect(() => {
    const ouraPreference = code && scope && state ? true : false;

    saveOuraTokenPreferences({
      code: code,
      scope: scope,
      state: state
    });

    updateNotificationPreferences({
      oura: ouraPreference
    });

    history.push(routesConfig.profile.path);
    history.push(routesConfig.notificationPreferences.path, {
      ouraPreference
    });
  });

  return <>.</>;

  async function saveOuraTokenPreferences(values: any): Promise<void> {
    try {
      await saveOuraTokensMutation({
        variables: {
          input: {
            ...values
          }
        }
      });
    } catch (error) {}
  }

  async function updateNotificationPreferences(values: any): Promise<void> {
    try {
      await updateNotificationPreferencesMutation({
        variables: {
          input: {
            ...values
          }
        }
      });
    } catch (error) {}
  }
};

export default track({
  url: "/oura"
})(Oura);
